import React, { useRef } from 'react';
import { Carousel as AntCarousel, Spin } from 'antd';
import type { CarouselRef } from 'antd/es/carousel';
import './Carousel.css';
import { useCarousel } from '../hooks/useCarousel';
import { getImageUrl } from '../utils/imageUtils';

interface SlideData {
  id: string;
  image: string;
  alt: string;
}

const Carousel: React.FC = () => {
  const carouselRef = useRef<CarouselRef>(null);
  
  // 从后台获取轮播图数据
  const { carouselImages, loading, error } = useCarousel();

  // 轮播图切换回调
  const handleSlideChange = (current: number): void => {
    // 可以在这里添加轮播图切换的逻辑
  };

  // 如果正在加载，显示加载状态
  if (loading) {
    return (
      <div className="carousel-container">
        <div className="carousel-loading">
          <Spin size="large" />
          <p>加载轮播图中...</p>
        </div>
      </div>
    );
  }

  // 如果有错误，显示错误信息
  if (error) {
    return (
      <div className="carousel-container">
        <div className="carousel-error">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  // 如果没有图片数据，显示默认内容
  if (!carouselImages || carouselImages.length === 0) {
    return (
      <div className="carousel-container">
        <div className="carousel-empty">
          <p>暂无轮播图数据</p>
        </div>
      </div>
    );
  }

  // 将后台数据转换为组件需要的格式
  const slides: SlideData[] = carouselImages
    .filter(img => img.isActive)
    .sort((a, b) => a.position - b.position)
    .map((img) => ({
      id: img._id,
      image: getImageUrl(img._id),
      alt: img.alt || img.originalName
    }));

  return (
    <div id="carousel" className="carousel-container">
      {/* Ant Design Carousel */}
      <AntCarousel
        ref={carouselRef}
        arrows={true}
        autoplay={{ dotDuration: true }}
        autoplaySpeed={3000}
        draggable={true}
        fade={true}
        dotPosition="bottom"
        afterChange={handleSlideChange}
        className="ant-carousel-custom"
      >
        {slides.map((slide) => (
          <div key={slide.id} className="carousel-slide">
            <div className="carousel-slide-content">
              <img src={slide.image} alt={slide.alt} />
            </div>
          </div>
        ))}
      </AntCarousel>
    </div>
  );
};

export default Carousel; 